var _desc, _ellipse, _path, _ellipse2, _path2, _ellipse3, _ellipse4, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSushi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId,
    "aria-describedby": "desc",
    role: "img",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    strokeWidth: 3,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Sushi Roll") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "A line styled icon from Orion Icon Library.")), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    ry: 5.999,
    rx: 11.999,
    cy: 22.014,
    cx: 14,
    "data-name": "layer1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M2 22.014v12c0 3.315 5.371 6 12 6s12-2.685 12-6v-12",
    "data-name": "layer1"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    ry: 5.999,
    rx: 11.999,
    cy: 11.988,
    cx: 34.009,
    "data-name": "layer1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.001 28.016l-40 21.996m41.998-5.998L16.001 58.012",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    "data-name": "layer2"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    ry: 0.857,
    rx: 2.571,
    cy: 21.988,
    cx: 14,
    "data-name": "layer2"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    ry: 0.856,
    rx: 2.571,
    cy: 11.961,
    cx: 34.009,
    "data-name": "layer2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M26 28.451a20 20 0 0 0 8.012 1.533c6.627 0 12-2.686 12-6v-12m-24.001.004v5.522",
    "data-name": "layer1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSushi);
export default __webpack_public_path__ + "static/media/sushi.8bff74bd.svg";
export { ForwardRef as ReactComponent };